import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
// import { Timepicker } from "react-timepicker";
// import TimePicker from 'react-time-picker';
import { Space, TimePicker } from 'antd';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Avatar, Card as LoadingCard, Skeleton, Switch } from 'antd';
const { Meta } = Card;
dayjs.extend(customParseFormat);

const DAY_START = "start";
const DAY_END = "end";

class ShiftTemplate extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    this.state = {
      myCompany: myCompany,
      servicesSize: "auto"
    };

    this.createSchedulesCard.bind(this);

    this.handleMyCompanyFieldChange.bind(this);
    this.handleNewWorkplaceFieldChange.bind(this);
    this.handleEntityFieldChange.bind(this);
    this.loadMyCompany.bind(this);
    this.loadMyCompanyWorkplaces.bind(this);
    this.loadMyEmployees.bind(this);
    this.saveMyCompany.bind(this);
    this.redirectTo.bind(this);
    this.addWeekDay.bind(this);
    this.deleteWeekDay.bind(this);
    this.createMainContent.bind(this);
    this.saveTemplate.bind(this);
    this.saveWeek.bind(this);
    this.addHour.bind(this);
    // this.getDayHour.bind(this);
    this.setDayHour.bind(this);
    this.setDayHourRange.bind(this);
    this.getDayHourRange.bind(this);
    this.deleteDayHourRange.bind(this);
    this.deleteWeek.bind(this);

    // let externalUsers = [
    //   "Oniti"
    // ];
    // if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
    //   this.props.history.push("/clientes");
    // }
  }
  componentDidMount() {
    if (!this.state.myCompany) {
      this.loadMyCompany();
    } else {
      this.loadMyTemplates(this.state.myCompany.uuid);
    }
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    this.props.saveMyCompany(this.state.myCompany);
    this.props.saveMyCompanyWorkplaces(this.state.myCompanyWorkplaces);
    this.props.saveMyEmployees(this.state.myEmployees);
  }
  async loadMyCompany() {
    this.setState({ isLoadingMyCompany: true });
    this.props.loadMyCompany().then(result => {
      this.setState({
        isLoadingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
      if (result.ok) {
        // this.loadMyCompanyWorkplaces(result.company.uuid);
        // this.loadMyEmployees(result.company.uuid);
        this.loadMyTemplates(result.company.uuid);
      } else {
        this.setState({ myCompanyWorkplaces: [] });
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyCompanyWorkplaces(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyCompanyWorkplaces: true });
    this.props.loadMyCompanyWorkplaces(company_id).then(result => {
      this.setState({
        isLoadingMyCompanyWorkplaces: false,
        myCompanyWorkplaces: result.ok ? result.workplaces : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los centros de trabajo de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyEmployees(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyEmployees: true });
    this.props.loadMyEmployees(company_id).then(result => {
      this.setState({
        isLoadingMyEmployees: false,
        myEmployees: result.ok ? result.employees : null
      });
      if (!result.ok) {
        this.setState({ myEmployees: [] });
      }
    })
    .catch((error) => {
      this.setState({
        isLoadingMyEmployees: false,
      });
      // Error 😨
      console.log("Error al cargar mis empleados: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyTemplates(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyTemplates: true });
    this.props.loadMyTemplates(company_id).then(result => {
      this.setState({
        isLoadingMyTemplates: false,
        myTemplates: result.ok ? result.templates : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar las plantillas de horarios de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveMyCompany() {
    this.setState({
      createCompany: false,
      isSavingMyCompany: true
    });
    this.props.saveMyCompany(this.state.myCompany).then(result => {
      this.setState({
        isSavingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveWorkplace(workplace) {
    this.setState({
      createWorkplace: false,
      editWorkplace: false,
      isSavingWorkplace: true
    });
    workplace = workplace || this.state.newWorkplace;
    workplace.company = this.state.myCompany.uuid;
    workplace = {
      id: workplace.id || null,
      name: workplace.workplaceName,
      street: workplace.workplaceStreet,
      postal_code: workplace.workplacePostalCode,
      locality: workplace.workplaceLocality,
      company: workplace.company
    };
    if (workplace.id) {
      let editingWorkplace = this.state.editingWorkplace;
      if (!editingWorkplace) editingWorkplace = [];
      editingWorkplace[workplace.id] = true;
      this.setState({
        editingWorkplace: editingWorkplace
      });
    } else {
      let workplaces = this.state.myCompanyWorkplaces;
      if (!workplaces) workplaces = [];
      workplace.isNew = true;
      workplaces["new"] = workplace;
    }
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveWorkplace(workplace).then(result => {
      this.setState({
        isSavingWorkplace: false,
        newWorkplace: null
      });
      if (workplace.id) {
        let editingWorkplace = this.state.editingWorkplace;
        if (!editingWorkplace) editingWorkplace = [];
        editingWorkplace[workplace.id] = false;
        this.setState({
          editingWorkplace: editingWorkplace
        });
      }
      this.loadMyCompanyWorkplaces();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveEmployee(employee) {
    this.setState({
      createEmployee: false,
      editEmployee: false,
      isSavingMyEmployee: true
    });
    employee = employee || this.state.newEmployee;
    employee.company = this.state.myCompany.uuid;
    // employee = {
    //   id: employee.id || null,
    //   name: employee.workplaceName,
    //   street: workplace.workplaceStreet,
    //   postal_code: workplace.workplacePostalCode,
    //   locality: workplace.workplaceLocality,
    //   company: workplace.company
    // };
    if (employee.id) {
      let editingEmployee = this.state.editingEmployee;
      if (!editingEmployee) editingEmployee = [];
      editingEmployee[employee.id] = true;
      this.setState({
        editingEmployee: editingEmployee
      });
    } else {
      let employees = this.state.myEmployees;
      if (!employees) employees = [];
      employee.isNew = true;
      employees["new"] = employee;
    }
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveEmployee(employee).then(result => {
      this.setState({
        isSavingMyEmployee: false,
        newEmployee: null
      });
      if (employee.id) {
        let editingEmployee = this.state.editingEmployee;
        if (!editingEmployee) editingEmployee = [];
        editingEmployee[employee.id] = false;
        this.setState({
          editingEmployee: editingEmployee
        });
      }
      this.loadMyEmployees();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empleado: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveTemplateServer(template) {
    // console.log("saveTemplateServer: template", template);
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveTemplate(template).then(result => {
      this.loadMyTemplates();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveTemplate(noClose) {
    // console.log("Save template: this.state.newTemplate", this.state.newTemplate);
    let template = this.state.newTemplate;
    let templates = this.state.myTemplates;
    if (!templates) templates = [];

    let newTemplateId = templates.length;
    if (this.state.createTemplate) {
      template.id = newTemplateId;
      templates[newTemplateId] = template;
      let serverTemplate = {
        name: template.name,
        weeks: template.weeks,
        company: this.state.myCompany.uuid
      };
      // console.log("Save template: serverTemplate", serverTemplate);
      this.saveTemplateServer(JSON.parse(JSON.stringify(serverTemplate)));
    } else {
      templates[template.id] = template;
      let serverTemplate = {
        id: template.id,
        name: template.name,
        weeks: template.weeks,
        company: this.state.myCompany.uuid
      };
      // console.log("Save template: serverTemplate", serverTemplate);
      this.saveTemplateServer(JSON.parse(JSON.stringify(serverTemplate)));
    }

    if (!noClose) {
      this.setState({
        newTemplate: null,
        myTemplates: templates,
        createTemplate: false,
        editTemplate: false
      });
    }
    return;
  }
  saveWeek() {
    let week = this.state.newWeek;
    delete week.isNew;
    let template = this.state.newTemplate;
    let weeks = template.weeks;
    if (!weeks) weeks = [];
    let newWeekId = weeks.length;
    if (this.state.createWeek) {
      week.id = newWeekId;
      weeks.push(week);
    } else {
      weeks[week.id] = week;
    }

    template.weeks = weeks;
    this.setState({
      newTemplate: template,
      newWeek: null,
      createWeek: false,
      editWeek: false
    });
    if (!template.isNew) this.saveTemplate(true);
    return;
  }
  deleteWeek() {
    let week = this.state.newWeek;
    let template = this.state.newTemplate;
    let weeks = template.weeks;
    let newWeeks = [];
    console.log("Delete week: week", week);
    console.log("Delete week: template", template);
    console.log("Delete week: weeks", weeks);
    if (weeks && weeks.length > 0) {
      weeks.map(_week => {
        if (_week.id !== week.id) newWeeks.push(_week);
      });
    }
    template.weeks = newWeeks;
    // this.setState({ newTemplate: template });
    this.setState({
      newTemplate: template,
      createWeek: false,
      newWeek: null,
      editWeek: null
    });
    if (!template.isNew) this.saveTemplate(true);
    return;
  }
  handleMyCompanyFieldChange(field, value) {
    this.handleEntityFieldChange("myCompany", field, value);
    // let myCompany = this.state.myCompany;
    // if (!myCompany) myCompany = {};
    // myCompany[field] = value;
    // this.setState({ myCompany: myCompany });
  }
  handleNewWorkplaceFieldChange(field, value) {
    this.handleEntityFieldChange("newWorkplace", field, value);
    // let newWorkplace = this.state.newWorkplace;
    // if (!newWorkplace) newWorkplace = {};
    // newWorkplace[field] = value;
    // this.setState({ newWorkplace: newWorkplace });
  }
  handleEntityFieldChange(entity_name, field, value) {
    let entity = this.state[entity_name];
    if (!entity) entity = {};
    entity[field] = value;
    this.setState({ [entity_name]: entity });
  }
  validateName(name) {
    if (!name) return false;
    if (name && name.length < 2) return false;
    return true;
  }
  addHour(dayNumber) {
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) return;
    let day = weekDays[dayNumber];
    let hours = day.hours;
    if (!hours) hours = [];
    let number = hours.length;
    let newHour = {
      start: null,
      end: null,
      number: number
    };
    hours[number] = newHour;
    weekDays[dayNumber].hours = hours;
    week.days = weekDays;
    this.setState({ week: week });
    return;
  }
  fillWeekDays(week) {
    // let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) weekDays = [];
    for (let i = 0; i < 7; i++) {
      if (!weekDays[i]) {
        let name = moment()
          .weekday(i)
          .format("dddd");
        weekDays[i] = {
          number: i,
          name: name,
          hours: []
        };
      }
    }
    week.days = weekDays;
    return week;
  }
  addWeekDay() {
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) weekDays = [];
    let number = weekDays.length;
    let name = moment()
      .weekday(number)
      .format("dddd");
    let newDay = {
      number: number,
      name: name,
      hours: []
    };
    weekDays[number] = newDay;
    week.days = weekDays;
    this.setState({ week: week });
    return;
  }
  deleteWeekDay(number) {
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) weekDays = [];
    let newWeekDays = [];
    if (weekDays && weekDays.length > 0) {
      weekDays.map(weekDay => {
        if (weekDay.number !== number) newWeekDays.push(weekDay);
      });
    }
    week.days = newWeekDays;
    this.setState({ week: week });
    return;
  }
  setDayHour(start_end, dayNumber, hourNumber, value) {
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) return null;

    let day = weekDays[dayNumber];
    let hours = day.hours;
    if (!hours) return null;

    let hour = hours[hourNumber];
    hour[start_end] = value;
    // let newHour = {
    //   start: null,
    //   end: null,
    //   number: number
    // };
    hours[hourNumber] = hour;
    weekDays[dayNumber].hours = hours;
    week.days = weekDays;
    this.setState({ week: week });
    return;
  }
  setDayHourRange(dayNumber, hourNumber, value) {
    if (!value) return;
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) return null;

    let day = weekDays[dayNumber];
    let hours = day.hours;
    if (!hours) return null;

    let hour = hours[hourNumber];
    hour.start = value[0].format("HH:mm");
    hour.end = value[1].format("HH:mm");
    // let newHour = {
    //   start: null,
    //   end: null,
    //   number: number
    // };
    hours[hourNumber] = hour;
    weekDays[dayNumber].hours = hours;
    week.days = weekDays;
    this.setState({ week: week });
    return;
  }
  getDayHourRange(hour) {
    if (!hour) return null;
    if (!hour.start || !hour.end) return null;
    let range = [dayjs(hour.start, "HH:mm"), dayjs(hour.end, "HH:mm")];
    return range;
  }
  getWeekHours(week, suffix) {
    if (!week) return;
    let weekDays = week.days;
    let totalHours = 0;
    if (weekDays && weekDays.length > 0) {
      weekDays.map(weekDay => {
        totalHours += this.getDayHours(weekDay);
        // let hours = weekDay.hours;
        // if (hours && hours.length > 0) {
        //   hours.map(hour => {
        //     if (hour.start && hour.end) {
        //       totalHours += dayjs(hour.end, "HH:mm").diff(
        //         dayjs(hour.start, "HH:mm"),
        //         "hour",
        //         true
        //       );
        //     }
        //   });
        // }
      });
    }
    if (suffix) {
      return totalHours + suffix;
    } else {
      return totalHours;
    }
  }
  getDayHours(weekDay, suffix) {
    let totalHours = 0;
    if (weekDay) {
      let hours = weekDay.hours;
      if (hours && hours.length > 0) {
        hours.map(hour => {
          if (hour.start && hour.end) {
            totalHours += dayjs(hour.end, "HH:mm").diff(
              dayjs(hour.start, "HH:mm"),
              "hour",
              true
            );
          }
        });
      }
    }
    if (suffix) {
      return totalHours + suffix;
    } else {
      return totalHours;
    }
  }
  deleteDayHourRange(dayNumber, hourNumber) {
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    if (!weekDays) return null;

    let day = weekDays[dayNumber];
    let hours = day.hours;
    if (!hours) return null;

    let newHours = [];
    if (hours && hours.length > 0) {
      hours.map(hour => {
        if (hour.number !== hourNumber) newHours.push(hour);
      });
    }
    weekDays[dayNumber].hours = newHours;
    week.days = weekDays;
    this.setState({ week: week });
    return;
  }
  buildEditHours() {
    let content = null;
    let week = this.state.newWeek;
    let weekDays = week ? week.days : null;
    let weekNameReady = week && this.validateName(week.name);
    if (!weekDays) weekDays = [];
    // let hours = this.state.newTemplate && this.state.newTemplate.weeks && this.state.newTemplate.weeks : null;
    content = (
      <Col className="text-center" xs={12}>
        Todavía no hay ningún día
      </Col>
    );
    if (weekDays.length > 0) {
      content = weekDays.map(weekDay => {
        let dayHours = this.getDayHours(weekDay);
        let dayClassName = dayHours > 0 ? "active-day" : "inactive-day";
        let hours = weekDay.hours;
        if (!hours) hours = [];
        let hoursContent = null;
        if (hours.length > 0) {
          hoursContent = hours.map(hour => {
            let hourRange = this.getDayHourRange(hour);
            return (
              <Col xs={12} key={"day-" + weekDay.name + "-hour-" + hour.number}>
                <Space direction="horizontal">
                  <TimePicker.RangePicker
                    onChange={(value) => {
                      // console.log("cambio del picker range", value);
                      this.setDayHourRange(weekDay.number, hour.number, value);
                    }}
                    status={hourRange ? null : "error"}
                    format="HH:mm"
                    value={hourRange}
                    defaultOpenValue={dayjs("00:00", "HH:mm")}
                    size="large"
                  />
                  <Button
                    className="eliminar-horario"
                    block 
                    color="primary"
                    size="sm"
                    icon
                    round
                    // disabled={!templateNameReady}
                    onClick={() => {
                      this.deleteDayHourRange(weekDay.number, hour.number);
                    }}
                    >
                    <i className="now-ui-icons ui-1_simple-remove" />
                  </Button>
                </Space>
              </Col>
            );
          });
        } else {
          hoursContent = <Col xs={12} className="text-center">Horario sin definir</Col>;
        }
        return (
          <Col
            className={"text-center day " + dayClassName}
            xs={12}
            key={"weekDay-" + weekDay.number}
          >
            <Card>
              <CardBody className="no-left-padding">
                <Row>
                  <Col xs={2}>
                    <span style={{ whiteSpace: "nowrap" }}>
                      <b>
                        {moment()
                          .weekday(weekDay.number)
                          .format("dddd")}
                      </b>
                    </span>
                    <br />
                    <span className="hours-summup no-margin">
                      {dayHours + "h"}
                    </span>
                  </Col>
                  <Col xs={10}>
                    <Row>
                      {hoursContent}
                      <Col className="text-center" xs={12}>
                        <Button
                          // block
                          color="primary"
                          size="lg"
                          onClick={() => {
                            this.addHour(weekDay.number);
                          }}
                        >
                          <i className="now-ui-icons ui-1_simple-add" /> Añadir horario
                        </Button>
                        {/* <Button
                          // block
                          // icon
                          disabled={weekDay.hours && weekDay.hours.length > 0}
                          color="danger"
                          size="lg"
                          onClick={() => {
                            this.deleteWeekDay(weekDay.number);
                          }}
                        >
                          <i className="now-ui-icons ui-1_simple-remove" />
                        </Button> */}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    }

    return (
      <Row
        key={"new-employee-weeks"}
        className="text-left employee-info new-employee"
      >
        <Col xs={12} key={"new-employee-weeks"}>
          <Row>
            <Col xs={12}>
              <CardBody className="no-left-padding">
                <h5 xs={12}><b>Horas laborales <span className="hours-summup">{this.getWeekHours(week, "h")}</span></b></h5>
                <Row>{content}</Row>
              </CardBody>
            </Col>
          </Row>
        </Col>
        {/* <Col className="text-center" xs={12}>
          {!weekNameReady && <span style={{ display: "block" }} className="text-danger">Primero nombra la semana</span>}
          <Button 
            disabled={(weekDays && weekDays.length > 6) || !weekNameReady}
            // block 
            color="primary" 
            size="lg"
            onClick={() => {
              this.addWeekDay();
            }}
            >
            <i className="now-ui-icons ui-1_simple-add" /> Añadir día
          </Button>
        </Col> */}
      </Row>
    );
  }
  buildEditWeeks() {
    let content = null;
    let templateNameReady = this.state.newTemplate && this.validateName(this.state.newTemplate.name);
    let weeks = this.state.newTemplate ? this.state.newTemplate.weeks : null;
    if (this.state.createWeek || this.state.editWeek) {
      let newWeek = this.state.newWeek;
      if (!newWeek) newWeek = {};
      let fields = [
        {
          title: "Nombre de la semana",
          name: "name",
          type: "text",
          placeholder: "Semana intensiva"
        },
        {
          title: "Horas laborales",
          name: "hours",
          type: "hours"
        }
      ];
      // let name = (newEmployee && newEmployee.name) ? newEmployee.name : "";
      // let surname1 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
      // let surname2 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
      // let email = (newEmployee && newEmployee.email) ? newEmployee.email : "";
      // let mobile = (newEmployee && newEmployee.mobile) ? newEmployee.mobile : "";
      // console.log(this.state);
      content = (
        <Col xs={12}>
          <Row className="text-left">
            <Col xs={12} md={12}>
              <CardHeader>
                {/* <b>
                  {newWeek.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nueva semana</span>) : (<span><i className="fa fa-edit" /> Editar semana</span>)}
                </b> */}
              </CardHeader>
            </Col>
            <Col xs={12} md={6}>
              <h5><i className="now-ui-icons ui-1_calendar-60" /> Configurar semana</h5>
              <span>Establece las horas laborales de cada día de la esta semana.</span>
            </Col>
            <Col xs={12} md={6}>
              {fields.map(field => {
                field.value = this.state.newWeek && this.state.newWeek[field.name] ? this.state.newWeek[field.name] : "";
                if (field.type !== "hours") {
                  return (
                    <Col key={"new-employee-" + field.name} xs={12}>
                      <Row className="text-left employee-info new-employee">
                        <Col xs={12}>
                          <CardBody className="no-left-padding">
                          <h5 md={3}><b>{field.title}</b></h5>
                          {/* <Label md={3}><b>{field.title}</b></Label> */}
                          <FormGroup>
                            <Input
                              {...field}
                              onChange={event =>
                                this.handleEntityFieldChange("newWeek", field.name, event.target.value)
                              }
                            />
                          </FormGroup>
                          </CardBody>
                        </Col>
                      </Row>
                    </Col>
                  );
                } else {
                  return <Col key={"new-employee-" + field.name} xs={12}>{this.buildEditHours()}</Col>;
                }
              })}
            </Col>
            <Col xs={12} lg={4}>
              <Button 
                block 
                color="success" 
                size="lg"
                onClick={() => {
                  this.saveWeek();
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar semana
              </Button>
            </Col>
            <Col xs={12} lg={4}>
              <Button 
                block 
                color="default" 
                size="lg"
                onClick={() => {
                  this.setState({
                    createWeek: false,
                    newWeek: null,
                    editWeek: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
            <Col xs={12} lg={4}>
              <Button 
                block 
                color="danger" 
                size="lg"
                onClick={() => {
                  console.log("Eliminar semana");
                  this.deleteWeek();
                  // this.saveTemplate();
                  // this.setState({ createCompany: false });
                }}
              >
                <i className="fa fa-trash" /> Eliminar
              </Button>
            </Col>
          </Row>
        </Col>
      );
    } else {
      if (weeks && weeks.length > 0) {
        content = (
          <Col xs={12} md={12} key={"new-employee-weeks"}>
            <CardBody className="no-left-padding">
              <h5 md={3}><b>Semanas</b></h5>
              <Row>
                {weeks.map(week => {
                  let weekHours = this.getWeekHours(week, "h");
                  if (!weekHours) weekHours = "0h";
                  return (
                    <Col key={"week-" + week.name} className="text-left semana" xs={12}>
                      <Card className="plain">
                        <CardHeader>
                          <b>{week.name}</b><br />
                          {weekHours.replace("h", "")} horas laborales
                        </CardHeader>
                        <CardBody className="no-left-padding">
                          {this.createMiniWeekSummup(week)}
                          <Button
                            className="configurar-semana"
                            block 
                            color="primary"
                            size="sm"
                            icon
                            round
                            // disabled={!templateNameReady}
                            onClick={() => {
                              this.setState({
                                editWeek: true,
                                newWeek: this.fillWeekDays(week)
                              });
                            }}
                            >
                            <i className="fa fa-cog" />
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
                <Col className="text-center" xs={12}>
                  {!templateNameReady && <span style={{ display: "block" }} className="text-danger">Primero nombra la plantilla</span>}
                  <Button 
                    // block 
                    color="primary" 
                    size="lg"
                    disabled={!templateNameReady}
                    onClick={() => {
                      this.setState({
                        createWeek: true,
                        newWeek: this.fillWeekDays({ isNew: true })
                      });
                    }}
                    >
                    <i className="now-ui-icons ui-1_simple-add" /> Nueva semana
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Col>
        );
      } else {
        content = (
          <Col xs={12} md={12} key={"new-employee-weeks"}>
            <CardBody className="no-left-padding">
              <h5 md={3}><b>Semanas</b></h5>
              <Row>
                <Col key={"week-no-hay-semana"} className="text-left semana" xs={12}>
                  <Card className="plain text-center">
                    <CardBody className="no-left-padding">
                      Todavía no hay ninguna semana
                    </CardBody>
                  </Card>
                </Col>
                {/* <Col className="text-center" xs={12}>Todavía no hay ninguna semana</Col> */}
                <Col className="text-center" xs={12}>
                  {!templateNameReady && <span style={{ display: "block" }} className="text-danger">Primero nombra la plantilla</span>}
                  <Button 
                    // block 
                    color="primary" 
                    size="lg"
                    disabled={!templateNameReady}
                    onClick={() => {
                      this.setState({
                        createWeek: true,
                        newWeek: this.fillWeekDays({ isNew: true })
                      });
                    }}
                  >
                    <i className="now-ui-icons ui-1_simple-add" /> Nueva semana
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Col>
        );
      }
    }

    return (
      <Row
        key={"new-employee-weeks"}
        className="text-left employee-info new-employee"
      >
        {content}
      </Row>
    );
  }
  createMiniWeekSummup(week) {
    if (!week) return null;
    let result = null;
    week = this.fillWeekDays(week);
    if (week.days && week.days.length > 0) {
      result = (
        <Row>
          {week.days.map(day => {
            let dayHours = this.getDayHours(day);
            let dayName = moment()
              .weekday(day.number)
              .format("dd");
            let dayClassName = dayHours > 0 ? "active-day" : "inactive-day";
            return (
              <Col
                key={"day-" + day.number + "-" + dayName}
                className={"day " + dayClassName}
                xs={12}
                md={3}
              >
                <Card>
                  <CardBody>
                    {dayName}
                    <span className="hours-summup">{dayHours + "h"}</span>
                  </CardBody>
                  {/* <CardBody>{this.createMiniWeekSummup(week)}</CardBody> */}
                </Card>
              </Col>
            );
          })}
        </Row>
      );
    } else {
      result = "Sin semanas";
    }
    return result;
  }
  createMiniTemplateSummup(template) {
    if (!template) return null;
    let result = null;
    if (template.weeks && template.weeks.length > 0) {
      result = (
        <Row>
          {template.weeks.map(week => {
            return (
              <Col xs={12} key={"week-" + week.number + "-" + week.name}>
                <Card>
                  <CardHeader>
                    <span className="week-name">{week.name}</span>
                    <span className="hours-summup">
                      {this.getWeekHours(week, "h")}
                    </span>
                  </CardHeader>
                  <CardBody>{this.createMiniWeekSummup(week)}</CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      );
    } else {
      result = "Sin semanas";
    }
    return result;
  }
  createMainContent() {
    let content = null;
    if (this.state.createWeek || this.state.editWeek) {
      let newTemplate = this.state.newTemplate;
      let templateName = newTemplate.name;
      let newWeek = this.state.newWeek;
      let weekName = newWeek.name;
      content = (
        <Row className="text-left">
          <Col xs={12}>
            <Row className="text-center employee-info new-employee row">
              <Col xs={12}>
                <CardBody className="h-nomargin"><b><span>Plantilla · {templateName}</span></b><br /></CardBody>
              </Col>
            </Row>
          </Col>
          {/* <Col xs={12} md={12}>
            <Row className="text-left employee-info new-employee row">
              <Col xs={12} md={12}>
                <CardHeader><b><span>Semana · {weekName}</span></b></CardHeader>
              </Col>
            </Row>
          </Col> */}
          <Col xs={12}>{this.buildEditWeeks()}</Col>
          {/* <Col xs={12}>{this.buildEditWeeks()}</Col> */}
        </Row>
      );
    } else if (this.state.createTemplate || this.state.editTemplate) {
      let newTemplate = this.state.newTemplate;
      if (!newTemplate) newTemplate = {};
      let fields = [
        {
          title: "Nombre de la plantilla",
          name: "name",
          type: "text",
          placeholder: "Jornada partida"
        },
        {
          title: "Semanas",
          name: "weeks",
          type: "weeks"
        }
      ];
      // let name = (newEmployee && newEmployee.name) ? newEmployee.name : "";
      // let surname1 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
      // let surname2 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
      // let email = (newEmployee && newEmployee.email) ? newEmployee.email : "";
      // let mobile = (newEmployee && newEmployee.mobile) ? newEmployee.mobile : "";
      // console.log(this.state);
      content = (
        <Row className="text-left">
          {/* <Col xs={12} md={12}>
            <CardHeader>
              <b>
                {newTemplate.isNew ? (<h5><i className="now-ui-icons ui-1_simple-add" /> Nueva plantilla</h5>) : (<h5><i className="fa fa-edit" /> Editar plantilla</h5>)}
              </b>
            </CardHeader>
          </Col> */}
          <Col xs={12}>
            <Row>
              <Col xs={12} md={6}>
                <CardBody className="no-left-padding">
                  <h5><i className="now-ui-icons ui-1_calendar-60" /> Información de la plantilla</h5>
                  <span>Indica el nombre y las semanas de la plantilla</span>
                </CardBody>
              </Col>
              <Col xs={12} md={6}>
                <Row>
                  {fields.map(field => {
                    field.value = this.state.newTemplate && this.state.newTemplate[field.name] ? this.state.newTemplate[field.name] : "";
                    if (field.type !== "weeks") {
                      return (
                        <Col key={"new-employee-" + field.name} xs={12}>
                          <Row className="text-left employee-info new-employee">
                            <Col xs={12}>
                              <CardBody className="no-left-padding">
                              <h5 md={3}><b>{field.title}</b></h5>
                              {/* <Label md={3}><b>{field.title}</b></Label> */}
                              <FormGroup>
                                <Input
                                  {...field}
                                  onChange={event =>
                                    this.handleEntityFieldChange("newTemplate", field.name, event.target.value)
                                  }
                                />
                              </FormGroup>
                              </CardBody>
                            </Col>
                          </Row>
                        </Col>
                      );
                    } else {
                      return <Col key={"new-employee-" + field.name} xs={12}>{this.buildEditWeeks()}</Col>;
                    }
                  })}
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xs={12} lg={4}>
            <Button 
              block 
              color="success" 
              size="lg"
              onClick={() => {
                this.saveTemplate();
                // this.setState({ createCompany: false });
              }}
              >
              Guardar
            </Button>
          </Col>
          <Col xs={12} lg={4}>
            <Button 
              block 
              color="default" 
              size="lg"
              onClick={() => {
                this.setState({
                  createTemplate: false,
                  newTemplate: null,
                  editTemplate: null
                });
              }}
              >
              Cancelar
            </Button>
          </Col>
          <Col xs={12} lg={4}>
            <Button 
              block 
              color="danger" 
              size="lg"
              onClick={() => {
                console.log("Eliminar plantilla");
                if (this.state.newTemplate.isNew) {
                  this.setState({
                    createTemplate: false,
                    newTemplate: null,
                    editTemplate: null
                  });
                }
                // this.saveTemplate();
                // this.setState({ createCompany: false });
              }}
            >
              <i className="fa fa-trash" /> Eliminar
            </Button>
          </Col>
        </Row>
      );
    } else {
      let templates = this.state.myTemplates || [];
      if (templates && Object.keys(templates).length > 0) {
        content = (
          <Col xs={12} md={12} key={"new-employee-weeks"}>
            {/* <h5 md={3}><b>Plantillas</b></h5> */}
            <Row className="plantilla-lista">
              {Object.keys(templates).map(templateId => {
                let template = templates[templateId];
                let templateSummup = this.createMiniTemplateSummup(template);
                return (
                  <Col key={"template-" + template.name + template.id} className="text-center semana plantilla" xs={12}>
                    <Card color="info">
                      <CardHeader>
                        <CardTitle>
                          <span className="nombre-plantilla">
                            <i className="fa fa-calendar" /> {template.name}
                          </span>
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col xs={12}>{templateSummup}</Col>
                        </Row>
                        <Button
                          className="configurar-semana"
                          block 
                          color="primary"
                          size="sm"
                          icon
                          round
                          // disabled={!templateNameReady}
                          onClick={() => {
                            this.setState({
                              editTemplate: true,
                              newTemplate: template
                            });
                          }}
                          >
                          <i className="fa fa-cog" />
                        </Button>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        );
      } else {
        content = (
          <Row>
            <Col xs={12} md={12}>
              No hay plantillas
              {/* <Button 
                block 
                color="primary" 
                size="sm"
                disabled={this.state.isSavingMyEmployee}
                onClick={() => {
                  this.setState({
                    newEmployee: {
                      isNew: true
                    },
                    createEmployee: true
                  });
                }}
                >
                {!this.state.isSavingMyEmployee ?
                  (<span><i className="now-ui-icons ui-1_simple-add" /> Añadir empleado</span>) :
                  (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Añadiendo</span>)
                }
              </Button> */}
            </Col>
          </Row>
        );
      }
    }
    return content;
  }
  createTemplateCardContent() {
    let content = null;
    if (this.state.isLoadingMyTemplates && !this.state.myTemplates) {
      content = (
        <Col xs={12} md={12}>
          <LoadingCard style={{ width: "100%", marginTop: 16 }} loading={true}>
            <Meta
              avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}
              title="Horario de la semana"
              description=""
            />
          </LoadingCard>
        </Col>
      );
    } else {
      return this.createMainContent();
    }
    return content;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  createSchedulesCard() {
    let card = null;
    let content = this.createTemplateCardContent();

    card = [
      <Col xs={12} key={"schedules-header"}>
        <Card id="my-employees-info" className="card-stats card-raised">
          <CardBody>
            <CardHeader>
              <h3>
                <span style={{ display: "block" }}>
                  <b>
                    <i className="now-ui-icons ui-1_calendar-60"></i> Plantillas
                    {(this.state.editTemplate || this.state.createTemplate) && <span> · {this.state.createTemplate ? "Nueva plantilla" : "Editar plantilla"}</span>}
                  </b>
                  {!this.state.createTemplate && <Button
                    onClick={() => {
                      this.setState({
                        newTemplate: { isNew: true },
                        createTemplate: true
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    style={{ float: "right",margin: 0 }}
                    // icon
                    // disabled={this.state.isSavingMyEmployee}
                  >
                    <i className="now-ui-icons ui-1_simple-add" /> Nueva
                  </Button>}
                </span>
              </h3>
              {/* {(this.state.myEmployees && !this.state.createEmployee) && <div className="corner-action-icon">
                <Button
                  onClick={() => {
                    this.setState({
                      newEmployee:  { isNew: true },
                      createEmployee: true
                    });
                  }}
                  color="primary"
                  size="sm"
                  round
                  // icon
                  disabled={this.state.isSavingMyEmployee}
                >
                  <i className="now-ui-icons ui-1_simple-add" /> Nuevo
                </Button>
              </div>} */}
            </CardHeader>
          </CardBody>
        </Card>
      </Col>,
      <Col xs={12} key={"schedules-content"}>
        <Card>
          <CardBody>{content}</CardBody>
        </Card>
      </Col>
    ];
    return card;
  }
  render() {
    // console.log("this.state", this.state);
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div>
          //     <h6 style={dashboardOrdersTitleStyle}>Evolución clientes</h6>
          //   <Line
          //     data={!this.state.customersChartReady? dashboardPanelChart.data : this.state.customersChart.data}
          //     options={!this.state.customersChartReady? dashboardPanelChart.options : this.state.customersChart.options}
          //   />
          //   </div>
          // }
        />
        <div className="content">
          <Row>
          </Row>
          <Row>
            {this.createSchedulesCard()}
          </Row>
        </div>
      </div>
    );
  }
}

export default ShiftTemplate;



// WEBPACK FOOTER //
// ./src/views/ShiftTemplate/ShiftTemplate.jsx